import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogActions, MatDialogClose, MatDialogContent, MatDialogModule, MatDialogTitle } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTreeModule } from '@angular/material/tree';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TranslateModule } from '@ngx-translate/core';
// import { CustomDialogComponent } from '../custom/custom-dialog/custom-dialog.component';
import { DatePickerComponent } from '../date-picker/date-picker.component';
import { SortPipe } from '../pipe/sort.pipe';
import { CustomPaginatorIntl } from './custom-paginator-intl';
// import { MatNativeDateModule } from '@angular/material/core';
import { CustomDialogComponent } from '../custom/custom-dialog/custom-dialog.component';
// import { MatButtonModule } from '@angular/material/button';
// import { MatGridListModule } from '@angular/material/grid-list';
// import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatIconModule } from '@angular/material/icon';
import { PageHeaderComponent } from '../page-header/page-header.component';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { PaginatorModule } from 'primeng/paginator';

@NgModule({
    declarations: [
        CustomDialogComponent,
        DatePickerComponent,
        SortPipe
    ],
    imports: [
        CommonModule,
        MatButtonModule,
        MatChipsModule,
        MatDatepickerModule,
        MatDialogActions,
        MatDialogClose,
        MatDialogContent,
        MatDialogModule,
        MatDialogTitle,
        MatExpansionModule,
        MatFormFieldModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatNativeDateModule,
        MatPaginatorModule,
        MatSelectModule,
        MatSidenavModule,
        MatSortModule,
        MatTableModule,
        MatTabsModule,
        MatTreeModule,
        MatRadioModule,
        ReactiveFormsModule,
        TranslateModule,
        MatDialogTitle,
        MatDialogContent,
        MatButtonModule,
        MatDialogActions,
        MatDialogClose,
        MatDatepickerModule,
        MatNativeDateModule,
        NgxMatSelectSearchModule,
        MatIconModule,
        PageHeaderComponent,
        CdkAccordionModule,
        PaginatorModule,

    ],
    exports: [
        CommonModule,
        DatePickerComponent,
        MatButtonModule,
        MatChipsModule,
        MatDatepickerModule,
        MatDialogActions,
        MatDialogClose,
        MatDialogContent,
        MatDialogModule,
        MatDialogTitle,
        MatExpansionModule,
        MatFormFieldModule,
        MatGridListModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatNativeDateModule,
        MatPaginatorModule,
        MatSelectModule,
        MatSidenavModule,
        MatSortModule,
        MatTableModule,
        MatTabsModule,
        MatTreeModule,
        ReactiveFormsModule,
        MatRadioModule,
        SortPipe,
        TranslateModule,
        MatDialogTitle,
        MatDialogContent,
        MatButtonModule,
        MatDialogActions,
        MatDialogClose,
        MatGridListModule,
        SortPipe,
        MatDatepickerModule,
        MatNativeDateModule,
        NgxMatSelectSearchModule,
        MatIconModule,
        PageHeaderComponent,
        CdkAccordionModule,
        PaginatorModule
    ],
    providers: [{ provide: MatPaginatorIntl, useClass: CustomPaginatorIntl }, MatDatepickerModule]
})
export class SharedModule { }
